import { mergeReferenceCatalogSections, repopulateReferenceCatalogSections } from '@database/catalogRowHelpers.mjs';
import { normalizeSyncUsuarioSections } from '@src/modules/platform/local-sqlite/infrastructure/normalizeSyncUsuarioSections.ts';
import type { SyncReferenceMergePort } from '../../domain/ports/SyncPorts.ts';
import type { GetSqlJsDatabase } from '@src/modules/platform/local-sqlite/infrastructure/sqlJsRowHelpers.ts';
import { markLocalSqliteDirty } from '@src/modules/platform/local-sqlite/infrastructure/localSqlitePersistDirty.ts';

export type GetSystemDatabase = GetSqlJsDatabase;

export class SqlJsCatalogPullMergeAdapter implements SyncReferenceMergePort {
  constructor(private readonly getDb: GetSqlJsDatabase) {}

  async merge(sections: Readonly<Record<string, unknown>>): Promise<number> {
    const db = this.getDb();
    if (!db) return 0;
    const normalized = await normalizeSyncUsuarioSections(sections);
    const n = mergeReferenceCatalogSections(db, normalized);
    if (n > 0) markLocalSqliteDirty();
    return n;
  }

  async repopulate(sections: Readonly<Record<string, unknown>>): Promise<number> {
    const db = this.getDb();
    if (!db) return 0;
    const normalized = await normalizeSyncUsuarioSections(sections);
    const n = repopulateReferenceCatalogSections(db, normalized);
    markLocalSqliteDirty();
    return n;
  }
}
